import { useState } from 'react'
import { Card, CardHeader, CardTitle, CardDescription, CardContent, Button, Input, Label } from '@/components/ui'
import { Calendar } from 'lucide-react'
import cronstrue from 'cronstrue'

export function CronEditor() {
  const [cron, setCron] = useState('*/5 * * * *')
  const [description, setDescription] = useState('')

  const handleCronChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newCron = e.target.value
    setCron(newCron)
    try {
      setDescription(cronstrue.toString(newCron))
    } catch (error) {
      setDescription('Invalid CRON expression')
    }
  }

  return (
    <div className="space-y-6">
      <div className="space-y-2">
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gradient-to-br from-blue-500/20 to-cyan-500/20">
            <Calendar className="h-6 w-6 text-blue-500" />
          </div>
          <div>
            <h1 className="text-2xl font-bold tracking-tight">CRON Job Editor</h1>
            <p className="text-muted-foreground">Create and validate CRON jobs</p>
          </div>
        </div>
      </div>

      <Card className="glass">
        <CardHeader>
          <CardTitle>CRON Expression</CardTitle>
          <CardDescription>Enter your CRON expression below</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label>Expression</Label>
            <Input
              value={cron}
              onChange={handleCronChange}
              placeholder="* * * * *"
              className="font-mono"
            />
          </div>
          <div>
            <Label>Description</Label>
            <p className="font-mono p-4 bg-muted/30 rounded-lg">{description}</p>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
